(function() {
  var TARGET_GRAMS = 28;
  var VALID_MESSAGE = 'Build Your Oz bundle locked at 28g. Remove the full bundle if you want to rebuild it.';
  var INVALID_MESSAGE = 'Build Your Oz bundles must stay together at exactly 28g. Remove and rebuild incomplete bundles before checkout.';
  var ACKNOWLEDGEMENT_MESSAGE = 'Confirm the 21+ and shipping eligibility acknowledgement before checkout.';
  var ACKNOWLEDGEMENT_STORAGE_KEY = 'petalzCheckoutAcknowledged';
  var isCheckingOut = false;
  var hasLoadedCart = false;
  var latestAnalysis = {
    hasBundles: false,
    isValid: true,
    groups: {},
    invalidGroups: []
  };

  function cartUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.replace(/\/$/, '') + path;
  }

  function acknowledgementInputs(form) {
    var inputs = Array.prototype.slice.call(document.querySelectorAll('[data-petalz-checkout-ack]'));

    if (!form) return inputs;

    return inputs.filter(function(input) {
      return input.form === form;
    });
  }

  function storedAcknowledgement() {
    try {
      return window.sessionStorage.getItem(ACKNOWLEDGEMENT_STORAGE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function storeAcknowledgement(isAcknowledged) {
    try {
      window.sessionStorage.setItem(ACKNOWLEDGEMENT_STORAGE_KEY, isAcknowledged ? 'true' : 'false');
    } catch (error) {
      // Keep the required checkbox as the source of truth if storage is unavailable.
    }
  }

  function syncAcknowledgementControls(source) {
    var inputs = acknowledgementInputs();
    var checked = source ? source.checked : storedAcknowledgement();

    if (!source && !checked) {
      checked = Array.prototype.some.call(inputs, function(input) {
        return input.checked;
      });
    }

    inputs.forEach(function(input) {
      input.checked = checked;
    });

    document.body.classList.toggle('petalz-checkout-ack-confirmed', checked);
  }

  function hasAcknowledgement(form) {
    var inputs = acknowledgementInputs(form);
    if (!inputs.length) return false;

    return Array.prototype.some.call(inputs, function(input) {
      return input.checked;
    });
  }

  function reportAcknowledgementRequired(form) {
    var input = acknowledgementInputs(form)[0] || acknowledgementInputs()[0];

    if (!input) {
      alert(ACKNOWLEDGEMENT_MESSAGE);
      return;
    }

    if (typeof input.reportValidity === 'function') {
      input.reportValidity();
    }

    try {
      input.focus({ preventScroll: false });
    } catch (error) {
      input.focus();
    }
  }

  function getProperty(item, key) {
    return item && item.properties ? item.properties[key] : undefined;
  }

  function isBuildYourOzItem(item) {
    return getProperty(item, '_Build Your Oz') === 'true' || Boolean(getProperty(item, '_BYO Bundle ID'));
  }

  function gramsFromItem(item) {
    var text = [item.variant_title || '', item.title || ''].join(' ');
    var variantMatch = text.match(/\b(1|4|7|14)g\b/i);
    if (variantMatch) {
      var variantGrams = parseInt(variantMatch[1], 10);
      return variantGrams === 4 || variantGrams === 7 ? variantGrams : 0;
    }

    var explicit = parseInt(getProperty(item, '_BYO Grams'), 10);
    return explicit === 4 || explicit === 7 ? explicit : 0;
  }

  function bundleIdFromItem(item) {
    return getProperty(item, '_BYO Bundle ID') || 'legacy-build-your-oz';
  }

  function analyzeCart(cart) {
    var groups = {};
    var invalidGroups = [];

    (cart.items || []).forEach(function(item) {
      if (!isBuildYourOzItem(item)) return;

      var bundleId = bundleIdFromItem(item);
      var grams = gramsFromItem(item);

      if (!groups[bundleId]) {
        groups[bundleId] = {
          id: bundleId,
          grams: 0,
          lines: [],
          missingGrams: false
        };
      }

      groups[bundleId].grams += grams * item.quantity;
      groups[bundleId].lines.push(item);
      if (!grams) groups[bundleId].missingGrams = true;
    });

    Object.keys(groups).forEach(function(id) {
      var group = groups[id];
      if (group.missingGrams || group.grams !== TARGET_GRAMS) {
        invalidGroups.push(group);
      }
    });

    return {
      groups: groups,
      hasBundles: Object.keys(groups).length > 0,
      invalidGroups: invalidGroups,
      isValid: invalidGroups.length === 0
    };
  }

  function fetchCart() {
    return fetch(cartUrl('/cart.js'), {
      headers: {
        Accept: 'application/json'
      }
    }).then(function(response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    });
  }

  function setCheckoutState(analysis) {
    var byoDisabled = analysis.hasBundles && !analysis.isValid;
    var acknowledgementDisabled = !hasAcknowledgement();
    var buttons = document.querySelectorAll('[name="checkout"], .cart__checkout-button');

    buttons.forEach(function(button) {
      var buttonAcknowledgementDisabled = !hasAcknowledgement(button.form);
      var disabled = byoDisabled || buttonAcknowledgementDisabled;

      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      if (disabled) {
        if (byoDisabled) {
          button.dataset.byoDisabled = 'true';
          button.removeAttribute('data-checkout-ack-disabled');
          button.title = INVALID_MESSAGE;
        } else {
          button.removeAttribute('data-byo-disabled');
          button.dataset.checkoutAckDisabled = 'true';
          button.title = ACKNOWLEDGEMENT_MESSAGE;
        }
      } else {
        button.removeAttribute('data-byo-disabled');
        button.removeAttribute('data-checkout-ack-disabled');
        button.removeAttribute('title');
      }
    });

    document.body.classList.toggle('petalz-byo-cart-has-bundle', analysis.hasBundles);
    document.body.classList.toggle('petalz-byo-cart-invalid', byoDisabled);
    document.body.classList.toggle('petalz-checkout-ack-missing', acknowledgementDisabled);
  }

  function guardHtml(analysis, placement) {
    if (!analysis.hasBundles) return '';

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    var status = analysis.isValid ? 'valid' : 'invalid';
    var message = analysis.isValid ? VALID_MESSAGE : INVALID_MESSAGE;
    var groups = Object.keys(analysis.groups).map(function(id) {
      var group = analysis.groups[id];
      var label = group.grams + 'g / ' + TARGET_GRAMS + 'g';
      var isInvalid = group.missingGrams || group.grams !== TARGET_GRAMS;
      var safeId = escapeHtml(id);
      var safeLabel = escapeHtml(label);

      return [
        '<li class="petalz-byo-cart-guard__bundle">',
        '<span>Build Your Oz</span>',
        '<strong class="' + (isInvalid ? 'is-invalid' : '') + '">' + safeLabel + '</strong>',
        '<button type="button" class="petalz-byo-cart-guard__remove" data-byo-remove-bundle="' + safeId + '">Remove bundle</button>',
        '</li>'
      ].join('');
    }).join('');

    return [
      '<div class="petalz-byo-cart-guard petalz-byo-cart-guard--' + status + ' petalz-byo-cart-guard--' + placement + '" data-byo-cart-guard>',
      '<p class="petalz-byo-cart-guard__message">' + message + '</p>',
      '<ul class="petalz-byo-cart-guard__bundles">',
      groups,
      '</ul>',
      '</div>'
    ].join('');
  }

  function replaceGuard(container, html, placement) {
    if (!container) return;

    container.querySelectorAll('[data-byo-cart-guard="' + placement + '"]').forEach(function(node) {
      node.remove();
    });

    if (!html) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var guard = wrapper.firstElementChild;
    guard.setAttribute('data-byo-cart-guard', placement);
    container.prepend(guard);
  }

  function renderGuards(analysis) {
    syncAcknowledgementControls();
    setCheckoutState(analysis);

    replaceGuard(
      document.querySelector('#main-cart-items .js-contents'),
      guardHtml(analysis, 'page'),
      'page'
    );

    replaceGuard(
      document.querySelector('#CartDrawer-CartItems'),
      guardHtml(analysis, 'drawer'),
      'drawer'
    );

    replaceGuard(
      document.querySelector('#cart-notification .cart-notification__links'),
      guardHtml(analysis, 'notification'),
      'notification'
    );
  }

  function removeBundle(bundleId) {
    fetchCart()
      .then(function(cart) {
        var updates = {};

        (cart.items || []).forEach(function(item) {
          if (isBuildYourOzItem(item) && bundleIdFromItem(item) === bundleId) {
            updates[item.key] = 0;
          }
        });

        if (!Object.keys(updates).length) return null;

        return fetch(cartUrl('/cart/update.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function(response) {
        if (response && !response.ok) throw new Error('Unable to remove bundle');
        window.location.reload();
      })
      .catch(function(error) {
        console.error(error);
        alert('Could not remove this Build Your Oz bundle. Please refresh and try again.');
      });
  }

  function validateCart() {
    return fetchCart()
      .then(function(cart) {
        var analysis = analyzeCart(cart);
        latestAnalysis = analysis;
        hasLoadedCart = true;
        renderGuards(analysis);
        return analysis;
      })
      .catch(function(error) {
        console.error(error);
        var fallbackAnalysis = {
          hasBundles: true,
          isValid: false,
          groups: {},
          invalidGroups: []
        };
        latestAnalysis = fallbackAnalysis;
        hasLoadedCart = true;
        renderGuards(fallbackAnalysis);
        return fallbackAnalysis;
      });
  }

  function continueCheckout(target) {
    var form = target && target.form ? target.form : target.closest && target.closest('form');

    if (!hasAcknowledgement(form)) {
      reportAcknowledgementRequired(form);
      setCheckoutState(latestAnalysis);
      return;
    }

    if (form && typeof form.reportValidity === 'function' && !form.reportValidity()) {
      return;
    }

    isCheckingOut = true;

    if (form) {
      var checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      form.appendChild(checkoutInput);
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    window.location.href = cartUrl('/checkout');
  }

  function handleCheckout(event) {
    var target = event.target.closest
      ? event.target.closest('[name="checkout"], .cart__checkout-button')
      : null;

    if (!target && event.type === 'submit' && event.target && event.target.querySelector) {
      target = event.target.querySelector('[name="checkout"], .cart__checkout-button');
    }

    if (!target || isCheckingOut) return;
    var targetForm = target.form ? target.form : target.closest && target.closest('form');
    if (hasLoadedCart && !latestAnalysis.hasBundles && hasAcknowledgement(targetForm)) return;

    event.preventDefault();
    event.stopPropagation();

    if (!hasAcknowledgement(targetForm)) {
      reportAcknowledgementRequired(targetForm);
      setCheckoutState(latestAnalysis);
      return;
    }

    validateCart().then(function(analysis) {
      if (!analysis.hasBundles || analysis.isValid) {
        continueCheckout(target);
      }
    });
  }

  function init() {
    syncAcknowledgementControls();
    setCheckoutState(latestAnalysis);
    validateCart();

    document.addEventListener('change', function(event) {
      var acknowledgement = event.target.closest
        ? event.target.closest('[data-petalz-checkout-ack]')
        : null;

      if (!acknowledgement) return;

      storeAcknowledgement(acknowledgement.checked);
      syncAcknowledgementControls(acknowledgement);
      setCheckoutState(latestAnalysis);
    });

    document.addEventListener('click', function(event) {
      var removeButton = event.target.closest('[data-byo-remove-bundle]');
      if (removeButton) {
        event.preventDefault();
        removeBundle(removeButton.getAttribute('data-byo-remove-bundle'));
        return;
      }

      handleCheckout(event);
    }, true);

    document.addEventListener('submit', function(event) {
      if (event.target && event.target.querySelector('[name="checkout"]')) {
        handleCheckout(event);
      }
    }, true);

    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
        validateCart();
      });
    }

    document.addEventListener('shopify:section:load', validateCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
